import React from 'react';

const Bard_Roles = () => {
  return (
    <div>
      <h1>Bard_Roles</h1>
      <p>This is the Bard_Roles component.</p>
    </div>
  );
};

export default Bard_Roles;
